class EventAddPageController {

  constructor($stateParams, $state, RacedaysService, AlertService, LocationService, EventService, LoaderService, Upload) {
    this.$stateParams = $stateParams;
    this.$state = $state;
    this.AlertService = AlertService;
    this.RacedaysService = RacedaysService;
    this.LocationService = LocationService;
    this.EventService = EventService;
    this.LoaderService = LoaderService;
    this.Upload = Upload;
  }

  $onInit() {
    var self = this;
    self.imageEndpoint = "/api/upload";
    self.files = {
      'header': null,
      'dynamicLink1': null,
      'dynamicLink2': null
    };
    self.validation = {};
    self.racedayId = self.$stateParams.id;

    // get raceday that this event will be attached to
    // self.RacedaysService.getById(self.racedayId)
    //     .then( (raceday) => self.raceday = raceday)
    //     .catch( (error) => self.AlertService.error('Error getting the Raceday for this event') );

    // get list of locations the this event will pick from
    // self.LocationService.getAll()
    //     .then( (locations) => self.locations = locations )
    //     .catch( (error) => self.AlertService.error('Error getting the Locations for this event') );

    // get empty event schema
    self.newEvent = angular.copy(self.EventService.getNew());
  }

  /**
   * Store file when chosen
   * @param picFile
   * @param type
   */
  storeFile(picFile, type) {
    this.files[type] = picFile;
  }

  save() {
    var self = this;

    if (!self.validForm()) {
      self.AlertService.error("The form has validation errors.");
      return;
    }

    self.LoaderService.start();
    self.EventService.addNew(self.newEvent, self.racedayId, self.files)
      .then(() => {
        // empty the file array
        self.files = {};
        self.AlertService.success("New Event has been added");
        self.$state.go('app.racedays.raceday.edit');
      })
      .catch((error) => {
        if (error.type === 'image') {
          self.validation = {};
          if (error.field === 'header') {
            self.files.raceday = null;
            self.validation.headerImage = error.message;
          }
          if (error.field === 'dynamicLink1') {
            self.files.dynamicLink1 = null;
            self.validation.dynamicLink1Image = error.message;
          }
          if (error.field === 'dynamicLink2') {
            self.files.dynamicLink2 = null;
            self.validation.dynamicLink2Image = error.message;
          }
          self.AlertService.error("There was a problem saving one or more of the event images.");
          // empty the file array
          self.files = {};
        }
        else {
          self.AlertService.error("There was a problem saving the Event");
        }
      })
      .finally(() => {
        self.LoaderService.stop();
      });
  }

  validForm() {
    var self = this;
    //validation

    self.validation = {};

    if (self.newEvent.name === undefined || self.newEvent.name === '') {
      self.validation.name = 'Event Title is required';
    }
    if (!self.files['header']) {
      self.validation.eventImage = 'You need to include an Event image';
    }
    if (self.newEvent.location === undefined || self.newEvent.location === null) {
      self.validation.location = 'Location is required';
    }

    //time req expr
    var re = /^([0-9]|0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/;

    if (self.newEvent.startTime === undefined || self.newEvent.startTime === '') {
      self.validation.startTime = 'Start Time is required';
    }
    else {
      if (!re.test(self.newEvent.startTime)) {
        self.validation.startTime = 'Enter as hh:mm';
      }
    }


    if (self.newEvent.description === undefined || self.newEvent.description === '') {
      self.validation.description = 'Location Description is required';
    }

    if ((!!self.newEvent.dynamicLink1.url.trim() && !self.newEvent.dynamicLink1.name.trim()) || (!!self.newEvent.dynamicLink1.name.trim() && !self.newEvent.dynamicLink1.url.trim())) {
      self.validation.dynamicLink1 = 'If using a dynamic link, both name and URL are required';
    } else if (self.newEvent.dynamicLink1.url.length > 0 && !self.newEvent.dynamicLink1.url.startsWith("http://") && !self.newEvent.dynamicLink1.url.startsWith("https://")) {
      self.validation.dynamicLink1 = 'Please ensure dynamic link URL starts with http:// or https://';
    }

    if ((!!self.newEvent.dynamicLink2.url.trim() && !self.newEvent.dynamicLink2.name.trim()) || (!!self.newEvent.dynamicLink2.name.trim() && !self.newEvent.dynamicLink2.url.trim())) {
      self.validation.dynamicLink2 = 'If using a dynamic link, both name and URL are required';
    } else if (self.newEvent.dynamicLink2.url.length > 0 && !self.newEvent.dynamicLink2.url.startsWith("http://") && !self.newEvent.dynamicLink2.url.startsWith("https://")) {
      self.validation.dynamicLink2 = 'Please ensure dynamic link URL starts with http:// or https://';
    }

    if (self.isEmpty(self.validation)) {
      return true;
    }
    else {
      return false;
    }

  }

  isEmpty(obj) {
    if (obj == null) return true;
    if (obj.length > 0) return false;
    if (obj.length === 0) return true;
    if (typeof obj !== "object") return true;
    for (var key in obj) {
      if (hasOwnProperty.call(obj, key)) return false;
    }
    return true;
  }

}
EventAddPageController.$inject = ['$stateParams', '$state', 'RacedaysService', 'AlertService', 'LocationService', 'EventService', 'LoaderService', 'Upload'];
export default EventAddPageController;
